// Adds selected complementary add-on products to the cart alongside the main product.
// The checkboxes are rendered by snippets/complementary-product.liquid; the quote flow
// reads the same checkboxes separately in product-delivery-options.js.
//
// The add-ons are added BEFORE the theme's own add-to-cart request: the theme's
// flyout fetches /cart.js right after its add, so adding ours first makes the
// flyout count and subtotal include the add-ons without a reload.
//
// Two line item properties ride on the main product:
// - "Selected Add-Ons": visible in the flyout, cart, and order.
// - "_Selected Add-Ons Data": hidden JSON ([{id, label}]) used to reconcile the
//   visible property when an add-on is later removed from the cart.
(function () {
  var VISIBLE_PROPERTY = 'Selected Add-Ons';
  var DATA_PROPERTY = '_Selected Add-Ons Data';
  var resubmitting = false;
  var reconciling = false;

  function getCheckedAddonCheckboxes() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-complementary-addon-checkbox]:checked')
    );
  }

  function addonEntry(checkbox) {
    return {
      id: parseInt(checkbox.dataset.addonVariantId, 10),
      label: checkbox.dataset.addonTitle + ' (' + checkbox.dataset.addonPrice + ')',
    };
  }

  function upsertHiddenInput(productForm, name, value) {
    var input = productForm.querySelector('input[name="properties[' + name + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      productForm.appendChild(input);
    }
    input.value = value;
  }

  function removeAddonPropertyInputs(productForm) {
    [VISIBLE_PROPERTY, DATA_PROPERTY].forEach(function (name) {
      var input = productForm.querySelector('input[name="properties[' + name + ']"]');
      if (input) input.remove();
    });
  }

  // When an add-on line is removed from the cart, trim it from (or drop) the
  // main product's properties so the order never claims an add-on that isn't there.
  function reconcileAddonProperties() {
    if (reconciling) return;
    reconciling = true;

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var variantIdsInCart = cart.items.map(function (item) { return item.variant_id; });
        var changes = cart.items
          .map(function (item) {
            var raw = item.properties && item.properties[DATA_PROPERTY];
            if (!raw) return null;
            var entries = JSON.parse(raw);
            var surviving = entries.filter(function (entry) {
              return variantIdsInCart.indexOf(entry.id) !== -1;
            });
            if (surviving.length === entries.length) return null;

            var properties = {};
            Object.keys(item.properties).forEach(function (key) {
              if (key !== VISIBLE_PROPERTY && key !== DATA_PROPERTY) {
                properties[key] = item.properties[key];
              }
            });
            var display = '';
            if (surviving.length) {
              display = surviving.map(function (entry) { return entry.label; }).join(', ');
              properties[VISIBLE_PROPERTY] = display;
              properties[DATA_PROPERTY] = JSON.stringify(surviving);
            }
            return { key: item.key, quantity: item.quantity, variantId: item.variant_id, properties: properties, display: display };
          })
          .filter(Boolean);

        return changes.reduce(function (chain, change) {
          return chain.then(function () {
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: change.key, quantity: change.quantity, properties: change.properties }),
            }).then(function () { patchCartLineDom(change.variantId, change.display); });
          });
        }, Promise.resolve());
      })
      .finally(function () { reconciling = false; });
  }

  function patchCartLineDom(variantId, display) {
    document
      .querySelectorAll('.cart-item[data-cartitem-id="' + variantId + '"] .cart-item--line-item-property')
      .forEach(function (propertyEl) {
        var nameEl = propertyEl.querySelector('.cart-item--option-name');
        if (!nameEl || nameEl.textContent.trim() !== VISIBLE_PROPERTY + ':') return;
        if (display) {
          propertyEl.textContent = ' ' + display;
          propertyEl.prepend(nameEl);
        } else {
          propertyEl.remove();
        }
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.api.integrations.register({
      id: 'complementary-addons',
      contact: 'https://envision.io',
      events: {
        'cart:updated': function () { reconcileAddonProperties(); },
      },
    });
    reconcileAddonProperties();

    var productForm = document.querySelector('form[data-product-form]');
    if (!productForm) return;

    document.addEventListener(
      'submit',
      function (event) {
        if (event.target !== productForm) return;
        if (resubmitting) {
          resubmitting = false;
          return;
        }

        var checkboxes = getCheckedAddonCheckboxes();
        if (!checkboxes.length) {
          // Nothing selected this time: drop any property left over from an earlier add.
          removeAddonPropertyInputs(productForm);
          return;
        }

        // Hold the theme's add-to-cart until the add-ons are in the cart.
        event.preventDefault();
        event.stopPropagation();

        var entries = checkboxes.map(addonEntry);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: entries.map(function (entry) { return { id: entry.id, quantity: 1 }; }),
          }),
        })
          .then(function (response) {
            if (response.ok) {
              upsertHiddenInput(
                productForm,
                VISIBLE_PROPERTY,
                entries.map(function (entry) { return entry.label; }).join(', ')
              );
              upsertHiddenInput(productForm, DATA_PROPERTY, JSON.stringify(entries));
            }
          })
          .finally(function () {
            resubmitting = true;
            productForm.dispatchEvent(new SubmitEvent('submit', { bubbles: true, cancelable: true }));
          });
      },
      true
    );
  });
})();
